import tokens from '@nike/design-system-base';

const xxl = tokens.spacing(6);
const xl = tokens.spacing(5);
const base = tokens.spacing(4);
const lg = tokens.spacing(3);
const sm = tokens.spacing(2);
const xs = tokens.spacing(1);

export default {
  block: {
    padding: {
      xxl,
      xl,
      base,
      lg,
      sm,
      xs,
    },
    margin: {
      xxl,
      xl,
      base,
      lg,
      sm,
      xs,
    },
  },
};
